import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ReviewWorkflowManager } from "@/components/ReviewWorkflowManager";
import { ReviewAnalyticsDashboard } from "@/components/ReviewAnalyticsDashboard";
import { ReviewNotificationCenter } from "@/components/ReviewNotificationCenter";
import { AdvancedWorkflowManager } from "@/components/AdvancedWorkflowManager";

export default function WorkflowAutomation() {
  return (
    <Tabs defaultValue="review" className="space-y-6">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="review">Review Workflows</TabsTrigger>
        <TabsTrigger value="analytics">Analytics</TabsTrigger>
        <TabsTrigger value="notifications">Notifications</TabsTrigger>
        <TabsTrigger value="general">General</TabsTrigger>
      </TabsList>
      
      <TabsContent value="review">
        <ReviewWorkflowManager />
      </TabsContent>
      
      <TabsContent value="analytics">
        <ReviewAnalyticsDashboard />
      </TabsContent>
      
      <TabsContent value="notifications">
        <ReviewNotificationCenter />
      </TabsContent>
      
      <TabsContent value="general">
        <AdvancedWorkflowManager />
      </TabsContent>
    </Tabs>
  );
}